<mat-sidenav-container class="et-header" [class.desktop-scrollbar]="isDesktop">
  <mat-sidenav #sidenav mode="over" opened="false" position="start">
    <div class="flex flex-col gap-2 grow sidenav-container">
      <div class="flex flex-row justify-between items-center">
        <img [routerLink]="['/']" alt="vi-logo" class="m-0 cursor-pointer" src="assets/media/vi-logo.svg" />
        <button
          (click)="onCloseSidenav()"
          mat-icon-button
          [disableRipple]="true"
          style="padding: 0; height: 24px; width: 24px"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if ((isAuthenticated$ | async) === false) {
        <et-login-screen
          (loginClicked)="onLogin()"
          (registerClicked)="onRegisterClicked()"
          [changeCatalogEnabled]="false"
          class="pt-[56px]"
        ></et-login-screen>
        <mat-divider></mat-divider>
      }

      @if (isAuthenticated$ | async) {
        <div class="mt-14">
          <span class="menu-group-label">{{ 'header.my_account' | translate }}</span>
        </div>

        <div class="flex flex-col justify-start gap-4 mt-6">
          <div (click)="onStartPageClicked(); sidenav.close()" class="menu-item">
            {{ 'header.start_page' | translate }}
          </div>
          <div (click)="onCatalogChange()" class="menu-item">
            {{ 'header.catalog_selection' | translate }}
          </div>
          <div (click)="onLanguageChange()" class="menu-item">
            {{ 'header.language_selection' | translate }}
          </div>
          <div (click)="onManageAccountClicked()" class="menu-item">
            {{ 'header.manage_account' | translate }}
          </div>
          <div (click)="onOpenOrders()" class="menu-item">
            {{ 'header.orders' | translate }}
          </div>
          <div (click)="onOtherViApps()" class="menu-item">
            {{ 'header.other_vi_apps' | translate }}
          </div>
          <div (click)="onLogout()" class="menu-item">
            {{ 'header.logout' | translate }}
          </div>
        </div>

        <div class="mt-14">
          <span class="menu-group-label">{{ 'header.assistance' | translate }} </span>
        </div>

        <div class="flex flex-col justify-start gap-4 mt-6">
          <div (click)="onSupportClicked()" class="menu-item">
            {{ 'header.support' | translate }}
          </div>
          <div (click)="onFeedbackClicked()" class="menu-item">
            {{ 'header.feedback' | translate }}
          </div>
        </div>
      }

      @if ((isAuthenticated$ | async) === false) {
        <div class="flex flex-col justify-start gap-4 mt-6">
          <div (click)="onCatalogChange()" class="menu-item">
            {{ 'header.catalog_selection' | translate }}
          </div>
          <div (click)="onLanguageChange()" class="menu-item">
            {{ 'header.language_selection' | translate }}
          </div>
          <div (click)="onSupportClicked()" class="menu-item">
            {{ 'header.support' | translate }}
          </div>
          <div (click)="onFeedbackClicked()" class="menu-item">
            {{ 'header.feedback' | translate }}
          </div>
        </div>
      }
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="vi-toolbar flex">
      <div class="flex flex-row gap-2 w-100">
        <button (click)="toggleSidenav()" mat-icon-button>
          <mat-icon>menu</mat-icon>
        </button>
        <div (click)="goToOverview()" class="flex flex-row gap-2 cursor-pointer items-center">
          <div class="block sm:hidden">
            <mat-icon [svgIcon]="'brand'"></mat-icon>
          </div>

          <img src="assets/icons/viessmann-logo.svg" class="w-36 hidden sm:block" />

          <div class="w-1 h-1 bg-white rounded-3xl"></div>
          <span class="text-white text-base font-normal leading-normal"> ViParts </span>
        </div>
        <span class="spacer"></span>
        <div class="flex flex-row items-center">
          @if (showCart$ | async) {
            <button (click)="onOpenCart()" mat-icon-button>
              @if (shoppingCartContent$ | async; as cart) {
                <mat-icon [matBadge]="getCartItemsQuantity(cart.items)"> shopping_cart</mat-icon>
              }
            </button>
            <button (click)="onFeedbackClicked()" mat-icon-button>
              <mat-icon>help</mat-icon>
            </button>
          }
          @if (isDesktop) {
            @if (appSwitcherContent$ | async; as appSwitcherContent) {
              @if (!!(authenticated$ | async)) {
                <dsw-app-switcher [appSwitcherContent]="appSwitcherContent"></dsw-app-switcher>
              }
            }
            <dsw-login
              (loginEvent)="onLogin()"
              (logoutEvent)="onLogout()"
              [authenticating]="!!(contextInfoLoading$ | async)"
              [isLoggedIn]="!!(authenticated$ | async)"
              [accountAppUrl]="accountUrl"
            ></dsw-login>
          }
        </div>
      </div>
    </div>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
